<div class="flex flex-col w-full">
  <!-- Header -->
  <div class="flex items-center justify-between px-6 py-4 border-b">
    <h2 class="text-2xl font-semibold">Upload Image to Selected {{ entityLabelPlural }}</h2>
    <button mat-icon-button (click)="close()" [disabled]="isLoading">
      <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col p-6 overflow-y-auto">
    <!-- Alert -->
    <fuse-alert class="mb-4" *ngIf="showAlert" [appearance]="'outline'" [type]="alert.type" [dismissible]="false">
      {{ alert.message }}
    </fuse-alert>

    <!-- Info Card -->
    <div class="mb-6 p-4 bg-primary bg-opacity-10 rounded-lg">
      <div class="flex items-start">
        <mat-icon class="text-primary mr-3" [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
        <div class="text-sm text-secondary">
          <p class="font-semibold mb-2">Selected {{ entityLabelPlural }}:</p>
          <p>
            You have selected <strong>{{ totalEntities }}</strong> {{ entityLabelPlural.toLowerCase() }}. The image you
            upload will be applied to all selected {{ entityLabelPlural.toLowerCase() }}.
          </p>
        </div>
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="form">
      <!-- Image Upload Section -->
      <div>
        <div class="text-lg font-medium mb-2">Select Image</div>
        <div class="text-sm text-secondary mb-4">Supported formats: JPG, PNG, WEBP, SVG (Max size: 10MB)</div>

        <!-- File Input (Hidden) -->
        <input
          #fileInput
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/webp,image/svg+xml"
          (change)="onFileSelected($event)"
          style="display: none"
        />

        <!-- Upload Button or Preview -->
        <div *ngIf="!selectedFile" class="flex items-center justify-center">
          <button
            type="button"
            mat-flat-button
            [color]="'primary'"
            (click)="fileInput.click()"
            class="w-full md:w-auto"
          >
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:photograph'"></mat-icon>
            <span class="ml-2">Choose Image</span>
          </button>
        </div>

        <!-- Image Preview -->
        <div *ngIf="selectedFile" class="mt-4">
          <div class="flex flex-col sm:flex-row items-start gap-4">
            <!-- Preview Image -->
            <div class="flex-shrink-0 w-full sm:w-auto flex justify-center sm:justify-start">
              <img
                *ngIf="imagePreview"
                [src]="imagePreview"
                alt="Preview"
                class="w-32 h-32 object-cover rounded-lg border-2 border-gray-300"
              />
            </div>

            <!-- File Info -->
            <div class="flex-1">
              <div class="flex items-center justify-between">
                <div>
                  <div class="font-medium">{{ selectedFile.name }}</div>
                  <div class="text-sm text-secondary mt-1">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</div>
                </div>

                <!-- Remove Button -->
                <button type="button" mat-icon-button (click)="clearFile()" [matTooltip]="'Remove image'">
                  <mat-icon class="text-warn" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
              </div>

              <!-- Change Image Button -->
              <button type="button" mat-stroked-button (click)="fileInput.click()" class="mt-3">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:refresh'"></mat-icon>
                <span class="ml-2">Change Image</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Error Message for Image -->
        <div *ngIf="form.get('image').touched && form.get('image').hasError('required')" class="mt-2">
          <span class="text-warn text-sm">Image is required</span>
        </div>
      </div>

      <!-- AI Generated Checkbox -->
      <div class="mt-4">
        <mat-checkbox [formControlName]="'isAiImage'">
          <span class="text-sm">Is AI Generated?</span>
        </mat-checkbox>
      </div>
    </form>

    <!-- Warning -->
    <div class="mt-6 p-4 bg-warn bg-opacity-10 rounded-lg">
      <div class="flex items-start">
        <mat-icon class="text-warn mr-3" [svgIcon]="'heroicons_outline:exclamation'"></mat-icon>
        <div class="text-sm text-secondary">
          <p class="font-semibold mb-2">Important:</p>
          <ul class="list-disc list-inside space-y-1">
            <li>
              This will upload the image to all {{ totalEntities }} selected {{ entityLabelPlural.toLowerCase() }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex items-center justify-end px-6 py-4 border-t bg-gray-50 dark:bg-transparent gap-3">
    <button mat-stroked-button (click)="close()" [disabled]="isLoading">
      <span>Cancel</span>
    </button>

    <button mat-flat-button [color]="'primary'" [disabled]="form.invalid || isLoading" (click)="upload()">
      <mat-icon *ngIf="!isLoading" class="icon-size-5" [svgIcon]="'heroicons_outline:upload'"></mat-icon>
      <mat-spinner *ngIf="isLoading" diameter="20" class="mr-2"></mat-spinner>
      <span class="ml-2">{{ isLoading ? 'Uploading...' : 'Upload Image' }}</span>
    </button>
  </div>
</div>
